export const CourierChargesMocks =  [
    {
        "courierChargesId" : 1,
        "weightSlab" : "0kg to 5kg",
        "rateperkg" : 350.00,
        "state" : "Karnataka",
    },
    {
        "courierChargesId" : 2,
        "weightSlab" : "5kg to 10kg",
        "rateperkg" : 700.00,
        "state" : "Pune",
    },
    {
        "courierChargesId" : 3,
        "weightSlab" : "10kg to 15kg",
        "rateperkg" : 1400.00,
        "state" : "Kerala",
    }
];